import React from 'react';
import { observer } from 'mobx-react';
import { Link, Checkbox, Typography, Button, Dialog, FormControlLabel } from '@material-ui/core';

import '../../styles/PopUp.scss';

const styles = {
  popupstyle: {
    width: '100%',
  },
  popupTitle: {
    width: '100%',
  },
  iconStyle: {
    alignSelf: 'center',
    marginRight: '10px',
  },
  panelStyle: {
    marginTop: '15px',
  },
};

const PopUp = observer(
  class PopupConfirmacionLecturaOfertaComponent extends React.Component {
    state = {
      checked: false,
    };

    onContinuar = () => {
      if (this.props.onContinuar) {
        this.props.onContinuar();
      }
    };

    onCancelar = () => {
      if (this.props.onCancelar) {
        this.props.onCancelar();
      }
    };

    descargarDocumento = () => {
      if (this.props.onDescargarDocumento) {
        this.props.onDescargarDocumento();
      }
    };

    render() {
      return (
        <Dialog id="modal" modal="true" open={this.props.open} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}>
                Confirmar Lectura
              </div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">
                <div className="aceptarCondiciones checkflotante">
                  <Typography>
                    Confirmo que descargué y tome conocimiento del{' '}
                    <Link onClick={this.descargarDocumento} underline="always" component="button" variant="body2">
                      documento de Ofertas de Portabilidad
                    </Link>{' '}
                    y sus condiciones presentadas
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={this.state.checked}
                        onChange={(evt, value) => {
                          this.setState({ checked: value });
                        }}
                      />
                    }
                   label=""/>
                </div>
              </div>
              <div className="boxButton">
                <Button id="btnPopUp" variant="contained" color="primary" onClick={this.onContinuar} className="btn-moradoModal" fullWidth={true} disabled={!this.state.checked}>
                  continuar
                </Button>
                <Button id="btnPopUp" variant="contained" color="secondary" onClick={this.onCancelar} className="btn-moradoModal" fullWidth={true}>
                  cerrar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

//const PopUp = withStyles(styles)(PopUpMandatoComponent);
export default PopUp;
